"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CellOptions = void 0;
const react_1 = __importDefault(require("react"));
const components_1 = require("@apitable/components");
const lodash_1 = require("lodash");
const styled_1 = require("./styled");
const COLOR_INDEX_THRESHOLD = 30;
const OptionItem = (props) => {
    const { text } = props, rest = __rest(props, ["text"]);
    return (react_1.default.createElement(styled_1.OptionItemStyled, Object.assign({}, rest), text));
};
const CellOptions = (props) => {
    const { options, selectOptions, className, style, cellClassName, cellStyle } = props;
    const renderOption = (option) => {
        var _a;
        const color = (_a = (0, lodash_1.find)(options, { id: option.id })) === null || _a === void 0 ? void 0 : _a.color;
        const textColor = color && color >= COLOR_INDEX_THRESHOLD ? components_1.black[50] : components_1.black[1000];
        return (react_1.default.createElement(OptionItem, { key: option.id, bg: option.color.value, text: option.name, textColor: textColor, className: cellClassName, style: cellStyle }));
    };
    if (!selectOptions) {
        return null;
    }
    if (Array.isArray(selectOptions)) {
        return (react_1.default.createElement(styled_1.OptionsWrapperStyled, { className: className, style: style }, (0, lodash_1.compact)(selectOptions).map(renderOption)));
    }
    return renderOption(selectOptions);
};
exports.CellOptions = CellOptions;
